import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import logo from '../assets/logo.svg';

const Container = styled.div`
  max-width: 400px;
  margin: 40px auto;
  padding: 20px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

const Logo = styled.img`
  width: 200px;
  margin-bottom: 30px;
`;

const Button = styled.button`
  width: 250px;
  padding: 12px 20px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  margin: 10px 0;

  &:hover {
    background-color: #45a049;
  }
`;

const SuccessMessage = styled.div`
  color: #4CAF50;
  font-size: 18px;
  margin: 20px 0;
  padding: 15px;
  border: 1px solid #4CAF50;
  border-radius: 4px;
  background-color: #f0fff0;
`;

function Dashboard() {
  const navigate = useNavigate();
  const location = useLocation();
  const [showOAuthSuccess, setShowOAuthSuccess] = useState(false);
  
  // Handle OAuth success redirect from backend
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const oauthResult = urlParams.get('oauth');
    
    if (oauthResult === 'success') {
      console.log('OAuth flow completed successfully via backend redirect!');
      setShowOAuthSuccess(true);
      
      // Clear the URL parameter
      window.history.replaceState(null, '', window.location.pathname);
      
      // Hide success message after 5 seconds
      setTimeout(() => {
        setShowOAuthSuccess(false);
      }, 5000);
    }
  }, [location]);

  const handleChooseDataRequest = () => {
    navigate('/data-request');
  };

  return (
    <Container>
      <Logo src={logo} alt="Logo" />
      
      {showOAuthSuccess && (
        <SuccessMessage>
          OAuth authorization completed successfully! You can now request PG&E data.
        </SuccessMessage>
      )}
      
      <SuccessMessage>
        Successfully connected to PG&E!
      </SuccessMessage>

      <Button onClick={handleChooseDataRequest}>
        Choose Data Request
      </Button>
    </Container>
  );
}

export default Dashboard;